import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';

export default class LocationTypeDto extends BaseAgencyScopeEntityDto {
    status = 0;
    name = '';
}